import { apiSlice } from '../store/api/apiSlice';

/**
 * Student API endpoints (shared across the Student feature).
 *
 * Injected into the shared RTK Query `apiSlice`.
 */
export const studentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET GetStudExpotureDetList — saved exposure-visit records for a school.
    // Response shape: { result: ExposureRecord[] }
    getExposure: builder.query<any, { schoolId: number }>({
      query: ({ schoolId }) => ({
        url: `GetStudExpotureDetListNew`,
        method: 'GET',
        params: { SchlId: schoolId },
        service: 'djangoEmis',
      }),
    }),

    // POST /api/tntp/SaveStudExpotureDet — save an exposure-visit record.
    postExposureVisit: builder.mutation<any, { records: Record<string, any> }>({
      query: (data) => ({
        url: `StudExpotureDetSave`,
        method: 'POST',
        body: data,
        service: 'djangoEmis',
      }),
    }),

    // POST StudentExposureUploads — save the uploaded photo/video keys.
    // Body: { records: { PhotoUpload, VideoUpload } }  (action_by comes from token)
    postExposureUploads: builder.mutation<
      any,
      {
        records: {
          PhotoUpload: string;
          VideoUpload: string;
          school_id: number | string;
        };
      }
    >({
      query: (data) => ({
        url: `StudentExposureUploads`,
        method: 'POST',
        body: data,
        service: 'djangoEmis',
      }),
    }),

    // POST StudExpotureDetSave — add or soft-delete a student in the
    // exposure-visit list.
    //   Add:    { records: { user_id, school_id } }
    //   Delete: { records: { user_id, school_id, isactive: 0 } }
    // Response: { dataStatus: boolean, message: string }
    addExposureStudent: builder.mutation<
      any,
      {
        records: {
          user_id: number;
          school_id: number;
          isactive?: number;
          user_type?: string;
          Noreason?: number | '';
          OtherReason?: string;
        };
      }
    >({
      query: (data) => ({
        url: `StudExpotureDetSave`,
        method: 'POST',
        body: data,
        service: 'djangoEmis',
      }),
    }),
  }),
});

export const {
  useGetExposureQuery,
  usePostExposureVisitMutation,
  useAddExposureStudentMutation,
  usePostExposureUploadsMutation,
} = studentApi;
